import DefaultLayout from "./DefaultLayout";

export default {
	name: "FullWidthLayout",

	extends: DefaultLayout,

	props: {
		maxWidth: {
			default: "none",
			type: String
		}
	}
};
